<template>
    <FormKit
            outer-class="mb-4 w-full"
            wrapper-class="max-w-full"
            label-class="block mb-1 p-0 font-medium text-lg"
            input-class="w-full rounded py-2 px-3 border leading-normal focus:ring-0"
            help-class="text-sm" />
</template>